import handleErrorDoCommon from './handleErrorDoCommon';

const wrapperResp = (response, config) => {
  const result = response.data;
  if (result.errorCode && result.errorCode !== '0') {
    if (config?.hasErrorHandle !== false) {
      handleErrorDoCommon(result, response);
    }
    return [null, result, response];
  }
  if (result.data === null || typeof result.data === 'undefined') {
    result.data = true;
  }
  return [result.data, null, response];
};

function createRequest(method, { url, data, config }) {
  const httpRequest = new XMLHttpRequest();

  let resolve;
  let reject;

  httpRequest.onreadystatechange = () => {
    if (httpRequest.readyState === 4) {
      if (httpRequest.status === 200) {
        const data = JSON.parse(httpRequest.responseText);
        const response = {
          data,
          config: {
            url
          },
          status: httpRequest.status
        };
        resolve(wrapperResp(response, config));
      } else {
        reject();
      }
    }
  };

  httpRequest.open(method, url, true);

  httpRequest.setRequestHeader('x-gray-version', process.env.projectId);
  httpRequest.setRequestHeader('Clientsource', process.env.clientSource);
  httpRequest.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  httpRequest.timeout = 28000;

  httpRequest.send(data ? JSON.stringify(data) : null);

  return new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
}

const ajax = {
  get(url, data, config) {
    return createRequest('GET', { url, data, config });
  },
  post(url, data, config) {
    return createRequest('POST', { url, data, config });
  },
  // url : 请求地址 params: 参数
  sendBeacon(url, params) {
    const blob = new Blob([JSON.stringify(params)], {
      type: 'application/json; charset=UTF-8'
    });
    // url = await mockDealUrl(url, proxyToMock);
    return navigator.sendBeacon(url, blob);
  }
};

export default ajax;
